import classNames from 'classnames';
import TopBrands from '@/components/header/components/mega-menu/top-brands';
import AllBrands from './all-brands';
interface Props {
  type: 'mobile' | 'desktop';
}
function Brands({
  type
}: Props) {
  return <div className={classNames({
    'absolute hidden': type === 'desktop'
  }, 'right-1/2 top-11 z-10 w-full transform cursor-auto rounded-b-md border-neutral-200 bg-white group-hover:block group-hover:text-neutral-600 md:h-[calc(100dvh-180px)] md:translate-x-1/2 md:overflow-hidden md:border-t md:pb-2 md:pt-4 md:shadow-low')} data-sentry-component="Brands" data-sentry-source-file="brands.tsx">
            <div className={classNames('flex h-full min-h-0 flex-col-reverse justify-start md:flex-row', {
      'layout-container': type === 'desktop'
    })}>
                <AllBrands type={type} data-sentry-element="AllBrands" data-sentry-source-file="brands.tsx" />
                {type === 'desktop' && <TopBrands mode='desktop' />}
            </div>
        </div>;
}
export default Brands;